import { gql } from "@apollo/client";

export const GET_ALL_DEVOTEES = gql`
  query GetAllDevotees {
    getAllDevotees {
      devotee_id
      devotee_name
      phone
      address
      gotram
      created_at
      updated_at
      relationName
    }
  }
`;


export const GET_DEVOTEE_BY_ID = gql`
  query GetDevoteeById($devotee_id: ID!) {
    getDevoteeById(devotee_id: $devotee_id) {
      devotee_id
      devotee_name
      phone
      address
      gotram
      created_at
      updated_at
      relationName
    }
  }
`;

export const CREATE_DEVOTEE = gql`
  mutation CreateDevotee($input: createDevoteeInput) {
    createDevotee(input: $input) {
      devotee_id
      devotee_name
      phone
      address
      gotram
      created_at
      updated_at
      relationName
    }
  }
`;


export const UPDATE_DEVOTEE = gql`
  mutation UpdateDevotee($input: updateDevoteeInput) {
    updateDevotee(input: $input) {
      devotee_id
      devotee_name
      phone
      address
      gotram
      relationName
      updated_at
    }
  }
`;


export const DELETE_DEVOTEE = gql`
  mutation DeleteDevotee($devotee_id: ID!) {
    deleteDevotee(devotee_id: $devotee_id)
  }
`;
